export { default as ExclamationIcon } from './ExclamationIcon';
